import {isPlatformBrowser} from '@angular/common';
import {Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID} from '@angular/core';
import {JWTService} from 'src/app/authentication/jwt.service';
import {Product} from "../../interface/product";
import {VolumeDiscountProfileItem} from "../../interface/volume-discount-profile-item";
import {WishlistService} from "../../../wishlist/wishlist.service";
import {Router} from "@angular/router";
import {ToastMessageService} from "../../../services/toast-message.service";

@Component({
	selector: 'fb-bulk-login-and-share-and-addtostoryboard-container',
	templateUrl: './bulk-login-and-share-and-addtostoryboard-container.component.html',
	styleUrls: ['./bulk-login-and-share-and-addtostoryboard-container.component.scss']
})
export class BulkLoginAndShareAndAddtostoryboardContainerComponent implements OnInit {

	constructor(
		private _jwt: JWTService,
		private _wishlist: WishlistService,
		private _router: Router,
		private _toast: ToastMessageService,
		@Inject(PLATFORM_ID) private _platformId: Object
	) {

	this.isBrowser = isPlatformBrowser(this._platformId);
	}
	public isBrowser: boolean = false;
	public bulkDiscountPrice: number = 0;
	@Input()
	public product: Product = {} as Product;
	@Output() closeVolumeDiscountOption = new EventEmitter();
	@Output() openVolumeDiscount = new EventEmitter();
	public inWishlist: boolean = false;

	public isLoggedIn = false;

	public tempopenVOlumeDiscount(): void { // this is temporary to show volume discount
		this.openVolumeDiscount.emit()
	}
	public sharePopup = false;
	public shareOpoupTriger(): void {
		this.sharePopup = true;
	}
	public closeVolumeDiscount(): void {
		// debugger
		this.closeVolumeDiscountOption.emit()
	}
	public closeShareModal(): void {
		this.sharePopup = false;
	}

	public ngOnInit(): void {

		this.inWishlist = this._wishlist.isInWishlist(this.product.sku);

		this._wishlist.wishlistItems.subscribe(() => {
			this.inWishlist = this._wishlist.isInWishlist(this.product.sku);
		});

		this.isLoggedIn = this._jwt.hasValidJWT();
		if(
			this.isLoggedIn &&
			this.product.volumeDiscountProfileEnabled &&
			this.product.volumeDiscountProfile &&
			this.product.volumeDiscountProfile?.volumeDiscountProfileItemList.length > 0
		) {
			this.product.volumeDiscountProfile.volumeDiscountProfileItemList.sort(
				(a: VolumeDiscountProfileItem, b: VolumeDiscountProfileItem) => b.discount - a.discount
			);
			let bulkDiscount: number = this.product.volumeDiscountProfile.volumeDiscountProfileItemList[0].discount;
			if (bulkDiscount) {
				this.bulkDiscountPrice = this.product.price - (this.product.price * (bulkDiscount / 100));
			}
			else {
				this.bulkDiscountPrice = this.product.price;
			}
		}

	}

	public storeUrl(): void {
		if (this.isBrowser) {
			localStorage.setItem("storeUrl",window.location.href)
		}

	}


	public toggleWishlist() {
		if(this.isLoggedIn) {
			this._wishlist.toggle(
				this.product.name,
				this.product.sku
			);
		}
		else {
			this.storeUrl();
			this._router.navigate(['/auth']).then(() => {
				this._toast.warning('Please Sign In to add to Wishlist', "Please login into your account to add to the wishlist");
			});
		}
	}
}
